import React from 'react';

/**
 * Creates the rendering base of a master page.
 * @param {MasterPageType} masterPageType
 * @param {JSX.Element} sideBarContent
 * @param {JSX.Element} mainAreaContent
 * @return {JSX.Element}
 * @constructor
 */
export default function MasterPageAbstract({ masterPageType, sideBarContent, mainAreaContent }) {
    return (
        <div className={`wcf-ui-master-page ${masterPageType}`}>
            <div className={'sidebar'}>{sideBarContent}</div>
            <div className={'main-area'}>{mainAreaContent}</div>
        </div>
    );
}
